import * as actionTypes from "../actions/types";
import produce from "immer";

const initialState = {
  isMoreInfo: false,
  selectMoreInfo: null,
};

let newData = [];
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  console.log("moreInfoReducer", payload);
  switch (type) {
    case actionTypes.OPEN_MORE_INFO_MODAL:
      draft.isMoreInfo = true;
      draft.selectMoreInfo = payload;
      return draft;
    case actionTypes.CLOSE_MORE_INFO_MODAL:
      draft.isMoreInfo = false;
      draft.selectMoreInfo = null;
      return draft;
    default:
      return draft;
  }
});
